import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Navbar from '../navbar/Navbar'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import Button from '@material-ui/core/Button';
import Footer from '../footer/footer'
import { Link } from "react-router-dom";



const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
}));

export default function ControlledExpansionPanels() {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = panel => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    
    
    return (
        <div className={classes.root}>
            <Navbar />
            <Link id='back' to="/QuestionBank">
                <Button style={{ margin: '10px',marginTop:'70px'  }} variant="contained" color="primary" href="#contained-buttons">
                    <KeyboardBackspaceIcon />
                </Button>
            </Link>
            <h1 id='desc' style={{textAlign:'center'}}>Eighth sem CSE/ISE QB</h1>
   

            <ExpansionPanel expanded={expanded === 'panel1'} onChange={handleChange('panel1')} style={{ marginTop: '40px' }}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Typography  className={classes.heading}>IOT</Typography>
                    <Typography  style={{marginLeft:'30px'}}  className={classes.secondaryHeading}>Not Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}>
                        <a href="https://drive.google.com/file/d/1j1_hxX230rOagaP7KBuoD4LLbNWzkOFs/view?usp=sharing">Module 1 and Module 2</a><br/>
                          
                        </div>
                    </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                >
                    <Typography className={classes.heading}>BDA</Typography>
                    <Typography  style={{marginLeft:'30px'}}  className={classes.secondaryHeading}> Available</Typography>
                </ExpansionPanelSummary>
                <Typography>
                       
                </Typography>
                <ExpansionPanelDetails>
                    <Typography>
                        <div style={{ color: 'black' }}>
                        <a href="https://drive.google.com/file/d/18T2fxW04hmSSoQxb8C8XGW2RiQL1aJw4/view?usp=sharing">2019(Question Paper)</a><br/>
                        <a href="https://drive.google.com/file/d/1xRKTOsx4amBl9bOfFlBPVQVTEQ7vtpRP/view?usp=sharing">Module 1</a><br/>
                         <a href="https://drive.google.com/file/d/1srIYMURg-_E9MK8XyKcwn5JBRIHDmmrd/view?usp=sharing">Module 2</a><br/>
                         <a href="https://drive.google.com/file/d/15Xu3hyz3iRC0omnT4SFkK3iX5rhjjmX5/view?usp=sharing">Module 3</a><br/>
                         <a href="https://drive.google.com/file/d/1v3-BOfXu0RTIaY1wPXn8xto1Sjxxr2xv/view?usp=sharing">Module 4</a><br/>
                         <a href="https://drive.google.com/file/d/1-STl4jBAg7u3lv5K0WAFpBX-Ot8HOwAr/view?usp=sharing">Module 5</a><br/>
                        
                        </div>

                    </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                >
                    <Typography className={classes.heading}>NMS</Typography>
                    <Typography  style={{marginLeft:'30px'}}  className={classes.secondaryHeading}>Not Available</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Typography>
                    <div style={{ color: 'black' }}>
                         
                          
                        </div>
          </Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>

           

           
         
            <Footer/>
        

            
        </div>
    );
}
